import { compact, forEach, isArray, findIndex, merge, remove } from 'lodash'
// @ts-ignore
import { formatPhoneNumber } from 'react-phone-number-input'

export const setScheme = (url: string) => {
  if (!/^(?:f|ht)tps?:\/\//.test(url)) {
    url = 'http://' + url
  }
  return url
}

export const getAddressString = (
  city: string,
  state: string,
  zipCode: string
) => {
  return compact([city, state, zipCode]).join(', ')
}

export const formatAddress = (
  street1: string,
  street2: string,
  city: string,
  state: string,
  zipCode: string
) => {
  return compact([street1, street2, city, state, zipCode]).join(', ')
}

const titles = {
  ADMIN: 'Admin',
  PHYSICIAN: 'Physician',
  RMA: 'RMA/CMA',
  NURSE: 'NURSE',
  BILLING_DEPARTMENT: 'Billing Department'

}
export const getTitle = (id: number) => {
  switch (id) {
    case 1:
      return titles.ADMIN
    case 2:
      return titles.PHYSICIAN
    case 3:
      return titles.RMA
    case 4:
      return titles.NURSE
    case 5:
      return titles.BILLING_DEPARTMENT
    default:
      return 'No Title Found'
  }
}

export const cmToInches = (centimeters: number): number =>  (centimeters && centimeters > 0 ? parseInt((centimeters * 0.3937008) + '', 10) : 0)
export const feetInchesTocm = (feet: number, inches: number): number => {
  feet = feet || 0
  inches = inches || 0
  const cm = ((+feet * 12) + +inches) * 2.54
  return +cm.toFixed(2)
}
export const cmToFeetInches = (cm: number) => {
  const inc = cmToInches(cm)
  const feet = inc !== 0 ? parseInt((inc / 12) + '', 10) : 0
  let inches = inc !== 0 ? (inc % 12).toFixed() : 0
  if (inches === '0') {inches = 0}
  return {feet, inches}
}
export const formatPhone = (phoneNumberString: string) => {
  try {
    return formatPhoneNumber(phoneNumberString)
  } catch (err) {
    console.error(err)
  }
  return null
}

export const secondsToMinutes = (seconds: number, textual = false): string | {mins: number, secs: number} => {
  if (!seconds) {
    if (textual) {
      return '0'
    } else {
      return {mins: 0, secs: 0}
    }
  }
  const mins = parseInt((seconds / 60) + '', 10)
  const secs = parseInt((seconds % 60) + '', 10)

  if (!textual) {
    return {mins, secs}
  }

  const minSec = []
  if (mins === 1) {
      minSec.push(`${mins} min`)
  } else if (mins > 0) {
    minSec.push(mins + ' mins')
  }
  if (secs > 1) {
      minSec.push(secs + ' secs')
  } else if (secs > 0) {
    minSec.push(secs + ' sec')
  }

  return minSec.join(' ')
}

export const minutesAndSecondsToSeconds = (minutes: number, seconds?: number) => {
  let totalSeconds = 0
  if ( minutes) {
    totalSeconds = +minutes * 60
  }
  if (seconds) {
    totalSeconds += +seconds
  }
  return totalSeconds
}

export const mergeArrayAndOverrideDuplicates = (existingArray: any[], newItem: any | any[], key = 'id') => {
  if (!existingArray) {
    existingArray = []
  }
  if (typeof newItem === 'number') {
    remove(existingArray, [key, newItem])
  } else {
    if (!isArray(newItem)) {
      newItem = [newItem]
    }

    forEach(newItem, item => {
      const foundIndex = findIndex(existingArray, [key, item[key]])
      if (foundIndex === -1) {
        existingArray.push(item)
      } else {
        existingArray[foundIndex] = merge(existingArray[foundIndex], item)
      }
    })
  }
  // @ts-ignore
  return [].concat(existingArray)
}
